import {
  DatabaseReference,
  DataSnapshot,
  off,
  onValue,
} from "firebase/database";
import { useRef } from "react";
import useSystemClock from "modules/system/hooks/useSystemClock";
import { useAppDispatch } from "store/hooks";
import announcementFirebase from "../announcement.firebase";
import { receivedAnnouncement, reset, setup } from "../redux/announcementSlice";
import { playAnnouncementSound } from "../../../helpers/audioHelper";
import { Announcement } from "../types";

const expiryTime = 30000; // 30s
// remove dispatch calls, move to callers
const useAnnouncementActions = () => {
  const dispatch = useAppDispatch();
  const { serverTime } = useSystemClock();
  const docRef = useRef<DatabaseReference>();

  const sendAnnouncement = (channel: string, announcement: Announcement) => {
    announcementFirebase.sendMessage(channel, announcement);
  };

  const clearAnnouncement = (channel: string) => {
    announcementFirebase.clearChannel(channel);
  };

  const setupAnnouncement = (data: { channel: string; sender: string }) => {
    dispatch(setup(data));
  };

  const subscribe = (channel: string) => {
    docRef.current = announcementFirebase.getAnnouncementDocRef(channel);
    off(docRef.current);
    onValue(docRef.current, (snapshot: DataSnapshot) => {
      const val = snapshot.val();

      if (!val || !val.message) {
        return;
      }

      if (val.sentAt > serverTime - expiryTime) {
        playAnnouncementSound();
        dispatch(
          receivedAnnouncement({
            id: val.id,
            sender: val.sender,
            sentAt: val.sentAt,
            message: val.message,
          }),
        );
      }
    });
  };

  const unsubscribe = () => {
    if (docRef.current) {
      off(docRef.current);
      dispatch(reset());
    }
  };

  return {
    setupAnnouncement,
    sendAnnouncement,
    clearAnnouncement,
    subscribe,
    unsubscribe,
  };
};

export default useAnnouncementActions;
